<template>
    <AlertDialogRoot :open="isOpen" @update:open="isOpen = $event">
        <AlertDialogPortal>
            <AlertDialogOverlay
                class="bg-black/50 backdrop-blur-sm fixed inset-0 z-[10000] animate-in fade-in duration-300" />
            <AlertDialogContent
                class="fixed top-1/2 left-1/2 z-[10001] w-[95vw] max-w-[450px] -translate-x-1/2 -translate-y-1/2 rounded-[32px] bg-white p-8 shadow-2xl focus:outline-none animate-in zoom-in-95 duration-300">
                <div class="flex flex-col items-center text-center">
                    <!-- Icon -->
                    <div :class="[
                        'w-20 h-20 rounded-full flex items-center justify-center mb-6 shadow-inner',
                        confirmState.type === 'destructive' ? 'bg-red-50 text-red-500' : 'bg-indigo-50 text-indigo-500'
                    ]">
                        <AlertTriangle v-if="confirmState.type === 'destructive'" :size="40" />
                        <HelpCircle v-else :size="40" />
                    </div>

                    <AlertDialogTitle class="text-2xl font-black text-slate-900 mb-2">
                        {{ confirmState.title }}
                    </AlertDialogTitle>
                    <AlertDialogDescription class="text-slate-500 text-sm leading-relaxed mb-8 max-w-xs">
                        {{ confirmState.message }}
                    </AlertDialogDescription>

                    <div class="flex gap-3 w-full">
                        <button @click="notificationStore.cancelAction"
                            class="flex-1 px-6 py-4 rounded-2xl text-[10px] font-black uppercase tracking-[0.2em] text-slate-400 hover:text-slate-600 hover:bg-slate-50 transition-all focus:outline-none border border-slate-100">
                            {{ confirmState.cancelLabel }}
                        </button>
                        <button @click="notificationStore.confirmAction" :class="[
                            'flex-1 px-6 py-4 rounded-2xl text-[10px] font-black uppercase tracking-[0.2em] text-white transition-all shadow-xl active:scale-[0.98] focus:outline-none',
                            confirmState.type === 'destructive'
                                ? 'bg-red-600 shadow-red-200 hover:bg-red-700'
                                : 'bg-slate-900 shadow-slate-200 hover:bg-slate-800'
                        ]">
                            {{ confirmState.confirmLabel }}
                        </button>
                    </div>
                </div>
            </AlertDialogContent>
        </AlertDialogPortal>
    </AlertDialogRoot>
</template>

<script setup>
import { computed } from 'vue'
import {
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogOverlay,
    AlertDialogPortal,
    AlertDialogRoot,
    AlertDialogTitle,
} from 'radix-vue'
import { AlertTriangle, HelpCircle } from 'lucide-vue-next'
import { useNotificationStore } from '@/stores/notification'
import { storeToRefs } from 'pinia'

const notificationStore = useNotificationStore()
const { confirmState } = storeToRefs(notificationStore)

const isOpen = computed({
    get: () => confirmState.value.isOpen,
    set: (val) => {
        if (!val) notificationStore.cancelAction()
    }
})
</script>
